module.exports = __webpack_public_path__ + "0f25bd7417f0d2642a817807e6ebba16.svg";